import { render, staticRenderFns } from "./tablette.vue?vue&type=template&id=23a71e36&scoped=true&"
import script from "./tablette.vue?vue&type=script&lang=js&"
export * from "./tablette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a71e36",
  null
  
)

export default component.exports